import httpInstance from "../httpInstance";

export const getResourceTypes = async (jwtToken: string) => {
    let res: any;
    const endpoint = `resourceTypes/`;

    // Configura el encabezado de autorización con el token JWT
    const config = {
        headers: {
            Authorization: `${jwtToken}`
        }
    };

    await httpInstance.get(endpoint, config)
        .then((data) => {
            res = data;
        })
        .catch((error) => {
            res = error.response;
        });
    return res;
}